import { getAboutApi } from "../../api/home/aboutApi";
import {
  GET_ABOUT_SUCCESS,
  GET_ABOUT_FAILURE,
} from "../types";

export const getAboutSuccess = (homepage) => ({
  type: GET_ABOUT_SUCCESS,
  payload: homepage,
});

export const getAboutFailure = (error) => ({
  type: GET_ABOUT_FAILURE,
  payload: error,
});

export const getAboutUs = (postData) => {
  return (dispatch) => {
    getAboutApi(postData)
      .then((response) => {
        dispatch(getAboutSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getAboutFailure(error.message));
      });
  };
};
